
import './blink.css';
import { Box, Typography } from '@mui/material';
export default function Announcement() {
  return (
    <section className="w-full py-3 md:py-3 lg:py-3 bg-gray-100 dark:bg-gray-800 relative" style={{background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(193,191,43,0.3785889355742297) 35%, rgba(3,185,185,0.31976540616246496) 78%, rgba(0,212,255,1) 100%)",
      fontFamily: "'Gill Sans', cursive"
    }}>
      {/* <div className="absolute inset-0 overflow-hidden">
        <img
          alt="Background Image"
          // className="h-full w-full object-cover opacity-20"
          height={500}
          src="/announce-bg.jpg"
          style={{
            aspectRatio: "600/400",
            objectFit: "cover",
          }}
          width={600}
        />
      </div> */}
      <div className="container px-4 md:px-6 text-center relative z-10">
        <div className="max-w-2xl mx-auto space-y-4">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl lg:text-3xl">Local Announcement!</h2>
          {/* <h3 className='blink_me' style={{color:"#d10000"}}>Bids opening exercise previously scheduled to hold 
          on 3rd of June 2024 had been shifted to 11th of June 2024.
           All inconveniences caused are highly regretted.
           </h3> */}
          <p className="text-teal-600	 md:text-xl dark:text-teal-600 font-bold	">
            INVITATION TO TENDER / EOI & PREQUALIFICATION
          </p>
          <a download
            className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-gray-900 text-gray-50 text-sm font-medium shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
            href="/local advert.docx"
          >
            Download the advert 1
          </a>
          &nbsp;&nbsp;
          <a download
            className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-gray-900 text-gray-50 text-sm font-medium shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
            href="/New Doc 03-18-2025 09.28.pdf"
          >
            Download the advert 2
          </a>
          &nbsp;&nbsp;

          <a download
            className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-gray-900 text-gray-50 text-sm font-medium shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
            href="/New Doc 03-18-2025 09.38.pdf"
          >
            Download the advert 3
          </a>
          &nbsp;&nbsp;
          <a download
            className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-gray-900 text-gray-50 text-sm font-medium shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
            href="/BID DOCUMENT.docx"
          >
            Download the bid document
          </a>
          &nbsp;&nbsp;

          <a download
            className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-gray-900 text-gray-50 text-sm font-medium shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
            href="/Addendum.pdf"
          >
            Download the addendum to the local advert
          </a>
        </div>
          <Box sx={{borderBlockColor:"red", p:2, m:2}}>
            <Typography variant="h4" sx={{color:"#d10000", fontWeight:"bold",mb:1}}>POSTPONEMENT OF BID OPENING EXERCISE</Typography>
            <a download className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-gray-900 text-gray-50 text-sm font-medium shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
              href="/POSTPONEMENT OF BID OPENING EXERCISE-2.docx">
              Download the details about the postponement of the bid opening exercise 
            </a>
          </Box>
      </div>
    </section>
  )
}